import {Routes} from '@angular/router';
import {InventoryItemShellComponent} from './lib/inventory-item/components/inventory-item-shell/inventory-item-shell.component';
import {OffersShellComponent} from './lib/offers/components/offers-shell/offers-shell.component';
import {QuestionsShellComponent} from './lib/questions/components/questions-shell/questions-shell.component';
import {DetailsShellComponent} from './lib/details/components/details-shell/details-shell.component';
import {SellReportPreviewShellComponent} from './lib/manage-inventory/components/sell-report-preview-shell/sell-report-preview-shell.component';
import { postingRoutes } from './lib/posting/posting.routes';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';
import { AmbassadorGuard } from '../app/guards/ambassador/ambassador.guard';
import { LayoutComponent } from './lib/manage-inventory/layout/layout.component';
import { AutoVisionShellComponent } from './lib/auto-vision/components/auto-vision-shell/auto-vision-shell.component';
import { AuctionSummaryArbitrationManageComponent, AuctionSummaryArbitrationResolver } from '../shared/arbitration';
import { AuthGuard, LaunchDarklyUserGuard, RoleBasedGuard } from 'remarketing-angular-library';
import { SalesReportComponent } from './lib/manage-inventory/components/sales-report/sales-report.component';
import { CsvFileDashboardComponent } from './lib/manage-inventory/components/csv-file-dashboard/csv-file-dashboard.component';
import { UnsavedFormGuard } from '../profile-management/guards/unsaved-form.guard';
import {
  inServiceVehicleRoutes
} from './lib/upload-in-service-vehicles/in-service-vehicles.routes';
import { FeatureGuard } from 'src/app/guards/feature.guard';
import { inject } from '@angular/core';
import {
  InventoryManagementLayoutComponent
} from '../inventory-management/components/layout/inventory-management-layout.component';
import {
  InventoryManagementReportPreviewShellComponent
} from '../inventory-management/components/sell-report-preview-shell/inventory-management-report-preview-shell.component';
import { inventoryManagementVersionGuard } from '../inventory-management/guards/inventory-management-version.guard';

export const sellRoutes: Routes = [
  {
    path: 'inventory',
    loadComponent: () => import('./lib/components/sell-shell/sell-shell.component').then(c => c.SellShellComponent),
    canActivate: [
      AgreementsGuard,
      AmbassadorGuard,
      AuthGuard,
      FeatureGuard,
      RoleBasedGuard,
    ],
    data: {
      featureName: 'sell',
      roles: ['View_Only'],
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    },
    children: [
      ...postingRoutes,
      ...inServiceVehicleRoutes,
      {
        path: '',
        canMatch: [inventoryManagementVersionGuard],
        component:  InventoryManagementLayoutComponent,
        pathMatch: 'full'
      },
      {
        path: '',
        component: LayoutComponent,
        pathMatch: 'full',
      },
      {
        path: 'report-previews',
        canMatch: [inventoryManagementVersionGuard],
        component: InventoryManagementReportPreviewShellComponent,
      },
      {
        path: 'report-previews',
        component: SellReportPreviewShellComponent
      },
      {
        path: 'sales-report',
        component: SalesReportComponent,
        canActivate: [LaunchDarklyUserGuard],
        data : { flag: 'menu-sell-salesReportVariation'},
      },
      {
        path: 'csv-dashboard',
        component: CsvFileDashboardComponent,
        canActivate: [LaunchDarklyUserGuard],
        data : { flag: 'admin-abgDashboardEnabled'},
      },
      {
        path: 'arbitration',
        data: { flag: 'sellerArbitrationEnabled'},
        canActivate: [LaunchDarklyUserGuard],
        children: [
          {
            path: 'new',
            redirectTo: '/inventory',
            pathMatch: 'full'
          },
          {
            path: ':auctionItemUuid/new',
            component: AuctionSummaryArbitrationManageComponent,
            canActivate: [AgreementsGuard],
            data: {
              guards: [
                GUARDS.TermsOfUseGuard,
                GUARDS.PrivacyPolicyGuard
              ]
            }
          },
          {
            path: ':auctionItemUuid/:claimNumber',
            resolve: {
              arbitration: AuctionSummaryArbitrationResolver,
            },
            component: AuctionSummaryArbitrationManageComponent,
            canActivate: [AgreementsGuard],
            canDeactivate: [UnsavedFormGuard],
            data: {
              guards: [
                GUARDS.TermsOfUseGuard,
                GUARDS.PrivacyPolicyGuard
              ]
            }
          },
        ]
      },
      {
        path: 'av',
        children: [
          {
            path: ':inventoryItemUuid',
            children: [
              {
                path: 'details',
                component: AutoVisionShellComponent
              },
              {
                path: '',
                redirectTo: 'details',
                pathMatch: 'full'
              }
            ]
          }
        ]
      },
      {
        path: ':inventoryItemUuid',
        component: InventoryItemShellComponent,
        children: [
          {
            path: 'details',
            component: DetailsShellComponent
          },
          {
            path: 'offers',
            component: OffersShellComponent
          },
          {
            path: 'questions',
            component: QuestionsShellComponent
          },
          {
            path: '',
            redirectTo: 'details',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: '**',
        redirectTo: '/404',
        pathMatch: 'full'
      }
    ]
  }
];
